import React, { useState } from 'react';
import { Modal, FormControl } from 'react-bootstrap';
import './css/timeMaster.css';

export default function TimeMaster({ parameters, onSendMessage, onExit }) {
    const eventId = parameters.config.event_id;

    const [clockLocalOffset, setClockLocalOffset] = useState(() => {
        const val = localStorage.getItem('clockLocalOffset_' + eventId);
        return val === null ? 0 : parseFloat(val);
    });
    const [broadcastDelay, setBroadcastDelay] = useState(() => {
        const val = localStorage.getItem('broadcastDelay_' + eventId);
        return val === null ? 0 : parseFloat(val);
    });
    const [requestorContact, setRequestorContact] = useState('');

    function handleTimeMaster(e) {
        if (e.target.name === 'requestorContact') {
            setRequestorContact(e.target.value);
        } else {
            const action = e.target.name === 'releaseTimeMaster' ? 'release_time_master'
                : e.target.name === 'setTimeMaster' ? 'set_time_master'
                : 'request_release_time_master';
            const msg = {
                sourceModuleName: 'ClockModule',
                event_grouping_seq: 0,
                customerID: parameters.userProfile.customer_id,
                siteID: parameters.userProfile.site_id,
                eventID: eventId,
                action,
            };
            if (e.target.name === 'requestRelease') msg.contact = requestorContact;
            onSendMessage(msg);
        }
    }

    function pickerUpClicked(e) {
        if (e.target.name === 'up') {
            const newNum = +(clockLocalOffset + 0.1).toFixed(1);
            setClockLocalOffset(newNum);
            localStorage.setItem('clockLocalOffset_' + eventId, newNum);
        } else if (e.target.name === 'upDelay') {
            const newNum = +(broadcastDelay + 1).toFixed(0);
            setBroadcastDelay(newNum);
            localStorage.setItem('broadcastDelay_' + eventId, newNum);
        }
    }

    function pickerDownClicked(e) {
        if (e.target.name === 'down') {
            const newNum = +(clockLocalOffset - 0.1).toFixed(1);
            if (newNum >= 0) {
                setClockLocalOffset(newNum);
                localStorage.setItem('clockLocalOffset_' + eventId, newNum);
            }
        } else if (e.target.name === 'downDelay') {
            const newNum = +(broadcastDelay - 1).toFixed(0);
            if (newNum >= 0) {
                setBroadcastDelay(newNum);
                localStorage.setItem('broadcastDelay_' + eventId, newNum);
            }
        }
    }

    const isMe = parameters.config.currentTimeMaster === 'ME';
    const hasMaster = parameters.config.currentTimeMaster !== '';

    const stepBtnStyle = {
        width: '30px', height: '30px', borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
        color: '#e0e0e0', fontSize: '18px', cursor: 'pointer', lineHeight: '1',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    };
    const valueLabelStyle = {
        fontSize: '24px', fontWeight: '300',
        backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)',
        borderRadius: '8px', padding: '4px 20px', minWidth: '70px',
        textAlign: 'center', display: 'inline-block', color: '#e0e0e0',
    };
    const actionBtnStyle = {
        borderRadius: '50px', paddingLeft: '14px', paddingRight: '14px',
        paddingTop: '4px', paddingBottom: '4px', lineHeight: '1.4', fontSize: '12px',
        backgroundColor: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.25)',
        color: '#e0e0e0', cursor: 'pointer',
    };
    const sectionLabelStyle = { fontSize: '11px', opacity: 0.55, marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' };

    let timeMasterContent;
    if (isMe) {
        timeMasterContent = (
            <div>
                <p style={{ marginTop: 0, lineHeight: 1.4 }}>You are the current Time Master. All clocks for this event will be set to the time of this device.</p>
                <button name="releaseTimeMaster" onClick={handleTimeMaster} style={actionBtnStyle}>Release</button>
            </div>
        );
    } else if (!hasMaster) {
        timeMasterContent = (
            <div>
                <p style={{ marginTop: 0, lineHeight: 1.4 }}>There is no Time Master.</p>
                <button name="setTimeMaster" onClick={handleTimeMaster} style={actionBtnStyle}>Become the Time Master</button>
            </div>
        );
    } else {
        timeMasterContent = (
            <div>
                <p style={{ marginTop: 0, lineHeight: 1.4 }}>The Time Master sits elsewhere. Enter your contact details to request release.</p>
                <FormControl type="text" name="requestorContact"
                    value={requestorContact} autoFocus={true}
                    placeholder="Your contact details"
                    style={{ width: '100%', marginBottom: '12px', backgroundColor: 'rgba(255,255,255,0.08)', color: '#e0e0e0', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '4px' }}
                    onChange={handleTimeMaster} />
                <button name="requestRelease" onClick={handleTimeMaster} style={actionBtnStyle}>Request Release</button>
            </div>
        );
    }

    return (
        <div className="outer-container">
            <Modal show={true} autoFocus={true} onHide={onExit} dialogClassName="dark-modal">
                <Modal.Header closeButton style={{ backgroundColor: '#1e1e1e', color: '#e0e0e0', borderColor: '#444' }}>
                    <Modal.Title style={{ color: '#e0e0e0', fontSize: '15px' }}>Clock Configuration</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: '#1e1e1e', color: '#e0e0e0', padding: '20px 24px' }}>
                    <div style={{ display: 'flex', gap: '28px', alignItems: 'flex-start' }}>
                        <div style={{ display: isMe ? 'none' : 'block' }}>
                            <div style={sectionLabelStyle}>Time offset (seconds)</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <button name="down" onClick={pickerDownClicked} style={stepBtnStyle}>−</button>
                                <span style={valueLabelStyle}>{clockLocalOffset}</span>
                                <button name="up" onClick={pickerUpClicked} style={stepBtnStyle}>+</button>
                            </div>
                        </div>
                        <div style={{ display: isMe ? 'block' : 'none' }}>
                            <div style={sectionLabelStyle}>Broadcast delay (seconds)</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <button name="downDelay" onClick={pickerDownClicked} style={stepBtnStyle}>−</button>
                                <span style={valueLabelStyle}>{broadcastDelay}</span>
                                <button name="upDelay" onClick={pickerUpClicked} style={stepBtnStyle}>+</button>
                            </div>
                        </div>
                        <div style={{ display: parameters.config.timeMaster ? 'block' : 'none', flex: 1, fontSize: '13px', borderLeft: '1px solid rgba(255,255,255,0.1)', paddingLeft: '24px' }}>
                            {timeMasterContent}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ backgroundColor: '#1e1e1e', borderColor: '#444' }}>
                    <button onClick={onExit} style={actionBtnStyle}>Close</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
